import produce from 'immer';
import { ActionTypes } from '../actions/navigation';

export const initialState = {
    navigationIsOpen: false,
};

function navigation(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            case ActionTypes.OPEN_NAVIGATION:
                draft.navigationIsOpen = true;
                return draft;
            case ActionTypes.CLOSE_NAVIGATION:
                draft.navigationIsOpen = false;
                return draft;
            default:
                return draft;
        }
    });
}

export default navigation;
